export default __webpack_public_path__ + "static/media/PlayIcon.396f1aff.svg";